import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	checkboxText: {
		fontSize: 14,
	},
	checkboxWrapper: {},
	container: {
		columnGap: '16px',
		display: 'grid',
		gridAutoFlow: 'column',
		gridTemplateColumns: 'repeat(2, 1fr)',
		// `gridTemplateRows` is set inline at render time from the item count
		// so column 1 fills first regardless of how many options exist.
		rowGap: 8,
	},
});
